import { useCallback } from 'react';
import { useUser } from '@clerk/clerk-react';
import { authenticatedFetch } from '../services/apiClient.js';

export function useSupabase() {
  const { user } = useUser();

  const saveData = useCallback(
    async (type, data) => {
      if (!user?.id) return;
      try {
        await authenticatedFetch('/api/save-data', {
          method: 'POST',
          body: JSON.stringify({ type, data }),
        });
      } catch (err) {
        console.error('[useSupabase] Save error:', err);
      }
    },
    [user?.id]
  );

  const syncFromCloud = useCallback(async () => {
    if (!user?.id) return null;
    try {
      const response = await authenticatedFetch('/api/user-sync', {
        method: 'POST',
        body: JSON.stringify({
          email: user.primaryEmailAddress?.emailAddress,
          name: user.firstName || '',
        }),
      });

      if (!response.ok) {
        const errBody = await response.json().catch(() => ({}));
        console.error(
          '[useSupabase] user-sync failed:',
          response.status,
          errBody
        );
        return null;
      }

      const data = await response.json();
      return data;
    } catch (err) {
      console.error('[useSupabase] Sync error:', err);
      return null;
    }
  }, [user?.id]);

  return { saveData, syncFromCloud };
}
